"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TSGameRandomViz = exports.TSGameNormal = void 0;
const TSBlock_1 = require("./TSBlock");
const TSColors_1 = require("./TSColors");
const Z20Generator_1 = require("./Z20Generator");
class TSGameNormal {
    constructor() {
        this.movingBlocks = [];
        this.moveNum = 0;
    }
    onStart(scene, setup, config) {
    }
    onWillMove(block) {
        this.moveNum++;
        for (const block of this.movingBlocks) {
            const next = block.path[this.moveNum % block.path.length];
            if (block.swaps)
                this.gameInterface.grid.swapWith(block, ...next);
            else
                this.gameInterface.grid.forceMoveTo(block, ...next);
        }
    }
    onDidMove(block, previousPos, desiredPos, successfullyMoved) {
        const lastDir = TSBlock_1.TSBlockMoving.DirForOffset([desiredPos[0] - previousPos[0], desiredPos[1] - previousPos[1]]);
        const others = this.gameInterface.blocksAt(desiredPos[0], desiredPos[1]);
        for (let i = 0; i < others.length; i++) {
            const oblock = others[i];
            if (oblock == block)
                continue;
            for (let fn of oblock.fns) {
                if (!oblock.isDead()) {
                    fn({ block: oblock, iface: this.gameInterface });
                }
            }
        }
    }
    addMovingBlock(block) {
        this.gameInterface.addBlock(block, block.path[0][0], block.path[0][1], false);
        this.movingBlocks.push(block);
    }
}
exports.TSGameNormal = TSGameNormal;
class TSGameRandomViz extends TSGameNormal {
    onStart(scene, setup, config) {
        let generator;
        const startTime = performance.now();
        let i = 0;
        for (; i < 1000; i++) {
            try {
                generator = new Z20Generator_1.Z20Generator(config, setup);
                break;
            }
            catch (e) {
                console.log(`Generation failed: ${e}`);
            }
        }
        const endTime = performance.now();
        console.log(`Took ${i + 1} tries to make a layout in ${endTime - startTime} ms`);
        for (let y = 0; y < config.size.y; y++) {
            for (let x = 0; x < config.size.x; x++) {
                if (generator.maze[x][y] === Z20Generator_1.Tile.Wall) {
                    this.gameInterface.addBlock(new TSBlock_1.TSBlock(scene, TSColors_1.TSBlockType.Tree, TSBlock_1.TSBlockAttribute.Blocks), x, y, false);
                }
            }
        }
        for (let blk of generator.nodes) {
            const actions = [];
            if (blk.entity.wins) {
                actions.push(TSBlock_1.TSBlock.BlockFnWin);
            }
            if (blk.entity.gives) {
                actions.push(TSBlock_1.TSBlock.BlockFnGiveItem(blk.entity.gives));
            }
            if (blk.entity.weakness) {
                actions.push(TSBlock_1.TSBlock.BlockFnDieIfItem(blk.entity.weakness));
            }
            if (blk.entity.kills) {
                actions.push(TSBlock_1.TSBlock.BlockFnLose);
            }
            this.gameInterface.addBlock(new TSBlock_1.TSBlock(scene, blk.entity, TSBlock_1.TSBlockAttribute.Blocks, actions), blk.loc.loc.x, blk.loc.loc.y, blk.entity.player);
        }
    }
}
exports.TSGameRandomViz = TSGameRandomViz;
